import { memo } from 'react';

/**
 * CalendarWidgetPainter — no longer renders floating cards directly.
 * CalendarCard2 instances are managed by JxWindowManager via CalendarEngine._syncWindows
 * and rendered by PageContent via jxWindowManager.paint().
 * This painter is kept as a mount point for future calendar-specific UI (e.g. UpcomingDrawer).
 */
function CalendarWidgetPainter() {
    return null;
}

export default memo(CalendarWidgetPainter);
